import { observer } from 'mobx-react-lite'
import { uiStore } from 'shared/store/uiStore'
import { AccessLayout, ConversationRoutes } from 'entities/ExportRouters'
import { EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'

export const ClientsAccessLayout = observer(() => {
  return (
    <AccessLayout
      name={EnumAccessPageKeys.clients}
      onAccessDenied={() => {
        uiStore.changeRouteViaVue({
          path: ConversationRoutes.root,
        })
      }}
    />
  )
})
